import * as React from 'react';
import type { SVGProps } from 'react';
const SvgHeartHandshakeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={21}
    fill="none"
    viewBox="0 0 18 21"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m14.408 10.739-5.541 6.19-5.542-6.19a4.2 4.2 0 0 1-.846-1.416 4.64 4.64 0 0 1 .078-3.341 4.2 4.2 0 0 1 .91-1.364 3.6 3.6 0 0 1 1.32-.838c.486-.173 1-.232 1.506-.17.508.06.998.24 1.44.525.444.285.83.67 1.134 1.132.305-.458.691-.84 1.134-1.123a3.4 3.4 0 0 1 1.438-.517 3.3 3.3 0 0 1 1.501.174c.485.174.932.458 1.314.836.383.378.692.841.908 1.36a4.643 4.643 0 0 1 .084 3.331 4.2 4.2 0 0 1-.838 1.416"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8.866 5.266 6.433 8.01a.9.9 0 0 0-.216.589.9.9 0 0 0 .216.59l.401.452c.51.575 1.338.575 1.848 0l.738-.834c.441-.497 1.04-.776 1.663-.776.624 0 1.222.279 1.662.776l1.663 1.875M9.236 13.18l1.478 1.666M11.084 11.102l1.478 1.666"
    />
  </svg>
);
export default SvgHeartHandshakeIcon;
